import React from 'react';

const AnimatedBackground = ({ variant = 'default' }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated Lines */}
      <div className="absolute inset-0">
        {/* Diagonal Lines */}
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-green-500/30 to-transparent animate-float transform rotate-12" style={{ left: '10%', animationDelay: '0s', animationDuration: '8s' }}></div>
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-green-400/20 to-transparent animate-float transform -rotate-12" style={{ left: '25%', animationDelay: '2s', animationDuration: '10s' }}></div>
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-primary-500/25 to-transparent animate-float transform rotate-45" style={{ left: '40%', animationDelay: '1s', animationDuration: '12s' }}></div>
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-green-300/15 to-transparent animate-float transform -rotate-6" style={{ left: '60%', animationDelay: '3s', animationDuration: '9s' }}></div>
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-accent-400/20 to-transparent animate-float transform rotate-30" style={{ left: '75%', animationDelay: '1.5s', animationDuration: '11s' }}></div>
        <div className="absolute w-px h-full bg-gradient-to-b from-transparent via-green-500/25 to-transparent animate-float transform -rotate-45" style={{ left: '90%', animationDelay: '4s', animationDuration: '7s' }}></div>

        {/* Horizontal Moving Lines */}
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-green-400/20 to-transparent animate-pulse" style={{ top: '15%', animationDelay: '0s', animationDuration: '6s' }}></div>
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-primary-400/15 to-transparent animate-pulse" style={{ top: '35%', animationDelay: '2s', animationDuration: '8s' }}></div>
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-green-300/20 to-transparent animate-pulse" style={{ top: '55%', animationDelay: '1s', animationDuration: '7s' }}></div>
        <div className="absolute h-px w-full bg-gradient-to-r from-transparent via-accent-300/15 to-transparent animate-pulse" style={{ top: '75%', animationDelay: '3s', animationDuration: '9s' }}></div>

        {/* Corner to Corner Lines */}
        <div className="absolute inset-0">
          <svg className="w-full h-full opacity-30" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="greenGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: 'transparent' }} />
                <stop offset="50%" style={{ stopColor: '#10b981', stopOpacity: 0.3 }} />
                <stop offset="100%" style={{ stopColor: 'transparent' }} />
              </linearGradient>
              <linearGradient id="greenGradient2" x1="100%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style={{ stopColor: 'transparent' }} />
                <stop offset="50%" style={{ stopColor: '#3b82f6', stopOpacity: 0.25 }} />
                <stop offset="100%" style={{ stopColor: 'transparent' }} />
              </linearGradient>
            </defs>
            
            <line x1="0" y1="0" x2="100%" y2="100%" stroke="url(#greenGradient1)" strokeWidth="1" className="animate-pulse" style={{ animationDelay: '0s', animationDuration: '4s' }} />
            <line x1="100%" y1="0" x2="0" y2="100%" stroke="url(#greenGradient2)" strokeWidth="1" className="animate-pulse" style={{ animationDelay: '2s', animationDuration: '6s' }} />
          </svg>
        </div>

        {/* Floating Particles */}
        <div className="absolute inset-0">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-green-400/40 rounded-full animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 8}s`,
                animationDuration: `${8 + Math.random() * 4}s`,
              }}
            />
          ))}
        </div>

        {/* Grid Pattern Overlay */}
        {variant === 'hero' && (
          <div 
            className="absolute inset-0 opacity-5"
            style={{
              backgroundImage: `
                linear-gradient(90deg, rgba(16, 185, 129, 0.1) 1px, transparent 1px),
                linear-gradient(180deg, rgba(16, 185, 129, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: '50px 50px',
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AnimatedBackground;
